"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.strPadLeft = exports.formatMinutesAndSeconds = exports.convertUTCDiffToRelativeSeconds = exports.addEventListenerOnce = void 0;

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Drew Burnett
 */
// Utils
var strPadLeft = function strPadLeft(string, pad, length) {
  return (new Array(length + 1).join(pad) + string).slice(-length);
};

exports.strPadLeft = strPadLeft;

var formatMinutesAndSeconds = function formatMinutesAndSeconds(time) {
  var minutes = Math.floor(time / 60);
  var seconds = Math.floor(time - minutes * 60);
  var result = strPadLeft(minutes, "0", 2) + ":" + strPadLeft(seconds, "0", 2);
  return result;
};

exports.formatMinutesAndSeconds = formatMinutesAndSeconds;

var convertUTCDiffToRelativeSeconds = function convertUTCDiffToRelativeSeconds(utcStartTime, utcEndtime) {
  return (utcEndtime - utcStartTime) / 1000;
};

exports.convertUTCDiffToRelativeSeconds = convertUTCDiffToRelativeSeconds;

var addEventListenerOnce = function addEventListenerOnce(element, event, fn) {
  var func = function func() {
    element.removeEventListener(event, func);
    fn();
  };

  element.addEventListener(event, func);
};

exports.addEventListenerOnce = addEventListenerOnce;